// M5.7 — сеть безопасности на 403 при блокировке оптики.
//
// MutationCache.onError (см. App.tsx) не имеет доступа к AntD-контексту, а
// значит и к тостеру. Поэтому тост-функцию регистрирует компонент-мост
// внутри <AntApp> (BlockedToastBridge), а onError лишь дёргает
// triggerBlockedToast(). Handler живёт на время монтирования приложения.

type BlockedToastHandler = () => void;

let handler: BlockedToastHandler | null = null;

export function setBlockedToastHandler(fn: BlockedToastHandler | null): void {
  handler = fn;
}

export function triggerBlockedToast(): void {
  handler?.();
}
